<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="spinner-container" v-if="this.loading">
    <div class="spinner" >
      <div class="spinner-inner"></div>
    </div>
    </div>
    <div v-else class="bg-white m-auto w-9/12 md:w-7/12 h-auto flex flex-col rounded-md justify-center items-center">
      <h2
        class="font-costea w-11/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
        Editar Usuario
      </h2>
      <!-- <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4">
          <span @click="$refs.myFiles.click()"
            class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
            <i class="ri-camera-fill text-lg"></i>
            <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
          </span>
        </div> -->
      <!-- <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
          :style="'background:' + showImage + ' no-repeat; background-size: cover; background-position:center'">
          <span @click="$refs.myFiles.click()"
            class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
            <i class="ri-camera-fill text-lg"></i>
            <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
          </span>
        </div> -->

      <!-- <p v-if="errorSizeImage"
          class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">
          {{ this.errorSizeImage }}
        </p> -->


      <form @submit.prevent="setUser" class="flex flex-col justify-start items-center w-11/12">
        <!-- <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
            <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full rounded-md">
              <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Usuario (e-mail)*
              </p>
              <input id="email" type="email" v-model="email" required
                class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                placeholder="example@dominio.com">
            </div>
          </div>
   -->
        <!-- <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
            <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full sm:w-6/12 rounded-md">
              <p for="password" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Contraseña*</p>
              <div
                class="border-gray-400 border w-full h-auto flex justify-start items-center outline-none pr-2 rounded-md text-t14">
                <input :type="typeControl" v-model="password" id="password" disabled
                  class="placeholder-gray-300 w-full flex justify-start items-center outline-none py-2 px-3 rounded-md text-t16"
                  placeholder="Contraseña">
                <i @click="showPassword('password')"
                  :class="iconShowPassword + ' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
              </div>
            </div>
            <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full sm:w-6/12 rounded-md">
              <p for="confirmPassword"
                :class="['w-full text-costeaGray items-center content-center text-t16 mb-3', { 'text-red-700': confirmPass }]">
                Confirmar contraseña*</p>
              <div
                :class="['border-gray-400 border w-full h-auto flex justify-start items-center outline-none pr-2 rounded-md text-t14', { 'border-red-700': confirmPass }]">
                <input disabled :type="typeControl" v-model="confirmPassword" id="confirmPassword" 
                  class="placeholder-gray-300 w-full flex justify-start items-center outline-none py-2 px-3 rounded-md text-t16"
                  placeholder="Contraseña">
                <i @click="showPassword('confirmPassword')"
                  :class="iconShowPassword + ' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
              </div>
            </div>
          </div> -->

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Nombre: *</p>
            <input id="name" type="text" v-model="user.name" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Primer Nombre">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Apellido: *</p>
            <input id="last_name" type="text" v-model="user.last_name" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Primer Apellido">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Teléfono: *</p>
            <input id="telephone" type="text" v-model="user.telephone" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Teléfono de contacto">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
              <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Rol: *</p>
              <select class="bg-white text-black-900 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide" required v-model="user.role_id" >
      <option disabled v-if="user.role_id == 1" class="text-black" value=1>1 - Super Administrador</option>
      <option v-if="user.role_id != 1" class="text-black" value=2>2 - Administrador</option>
      <option v-if="user.role_id != 1" class="text-black" value=3>3 - Consulta</option>
    </select>

            </div>
          </div>

        <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-end">
          <button
            class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
            @click="toggleModal()" type="button">Cancelar</button>
          <div v-show="this.buttonText == 'Creando...'"
            class="bg-costeaPrimary rounded-md text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4">
            Editando...</div>
          <button :disabled="this.disabledButton" v-show="this.buttonText == 'Crear' || this.buttonText == '¡Listo!'"
            :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
            type="submit">{{ buttonText }}</button>
        </div>
      </form>

    </div>

  </div>
</template>
  
<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      notValid: '',

      // iconShowPassword: 'ri-eye-off-line',
      // typeControl: 'password',

      // iconShowPassword2: 'ri-eye-off-line',
      // typeControl2: 'password',

      // cop: false,
      // usd: false,
      buttonText: 'Crear',
      buttonBg: 'bg-costeaPrimary',
      modalAct: true,

      disabledButton: false,
      loading:true,

      // name: '',
      // last_name: '',
      // doc_type: 'ID',
      // num_doc_type: '12345678',
      // emailUser: '',
      // password: '',
      // confirmPassword: '',
      // role_id: 2,
      // telephone: '',
      // gender: 'x',
      // picture: null,
      // previewImage: null,


      // errorSizeImage: '',
      //   userForm: {
      //       created_at: "",
      //       doc_type: null,
      //       email: "",
      //       email_verified_at: null,
      //       gender: "",
      //       id: 1,
      //       last_name: null,
      //       name: "",
      //       num_doc_type: null,
      //       picture: null,
      //       role_id: 1,
      //       telephone: "",
      //       updated_at: ""
      //   }
      user: {}
    }
  },
  props: ['id'],

  computed: {
    ...mapState(['costea']),
    //   confirmPass() {
    //     if (this.confirmPassword != '') {
    //       if (this.confirmPassword === this.password) {
    //         // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //         this.notValid = false
    //       } else {
    //         // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //         this.notValid = true
    //       }
    //     }
    //     return this.notValid
    //   },
    //   showImage() {
    //     if (this.previewImage != null) {
    //       return 'url(' + this.previewImage + ')'
    //     } else {
    //       return '#f1f2f3'
    //     }
    //   },

  },
  async mounted() {
    await this.getUserById(this.id)
    this.loading = false
  },
  methods: {
    setUser: function () {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  let payload = {
    name: this.user.name,
    id: this.user.id,
    last_name: this.user.last_name,
    doc_type: this.user.doc_type,
    num_doc_type: this.user.num_doc_type,
    email: this.user.email,
    role_id: parseInt(this.user.role_id),
    telephone: this.user.telephone,
    gender: this.user.gender
  }
  axios
    .put(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}user/${this.user.id}`, payload, config)
    .then(() => {
      setTimeout(() => {
        this.buttonText = 'Listo!'
        this.disabledButton = true
        this.buttonBg = 'bg-costeaDarkGreen'
      }, 100)
      setTimeout(() => {
        this.toggleModal()
      }, 1000)
      setTimeout(() => {
        this.buttonText = 'Editar'
        this.disabledButton = false
        this.buttonBg = 'bg-costeaPrimary'
      }, 3000)
    })
    .catch((error) => {
      console.log(error)
    });
},

    //   onSelectedImage(event) {
    //     this.picture = event.target.files[0]
    //   },
    //   pickFile() {
    //     let input = this.$refs.myFiles
    //     let file = input.files
    //     if (file && file[0]) {
    //       let reader = new FileReader
    //       reader.onload = e => {
    //         this.previewImage = e.target.result
    //       }
    //       reader.readAsDataURL(file[0])
    //     }
    //   },
    validateUsers() {
      if (this.notValid === false) {
        this.buttonText = 'Creando...'
        this.setUsers()
      } else {
        this.notValid = true
      }
    },
    //   setUsers: function () {

    //     axios
    //       .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}register-user`,
    //         formData, config)
    //       .then(() => {
    //         setTimeout(() => {
    //           this.buttonText = 'Listo!'
    //           this.disabledButton = true
    //           this.buttonBg = 'bg-costeaDarkGreen'
    //         }, 100)
    //         setTimeout(() => {
    //           this.toggleModal()
    //         }, 1000)
    //         setTimeout(() => {
    //           this.buttonText = 'Editar'
    //           this.disabledButton = false
    //           this.buttonBg = 'bg-costeaPrimary'
    //         }, 3000)
    //       }
    //       ).catch(
    //         (error) => {
    //           console.log(error)

    //         }
    //       );
    //   },
    async getUserById(id) {
      await axios
        .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}user/${id}`)
        .then(respuesta => {
          // if(respuesta.data.status == false){
          //   this.$router.push('/login')                                                                                                  
          // }
          this.user = respuesta.data.data;
          this.pages = []
          // this.setPages()
        }).catch((error) => {
          // if (error.response.status === 401) {
            console.log(error)
          // }
        })
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalEdit', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Creando...'
    },

    //Bonus

  }
}
</script>
  
<style scoped>
.addmodal {
  background: rgba(0, 0, 0, 0.6);
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  position: relative;
  width: 40px;
  height: 40px;
}

.spinner-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #ccc;
  border-top-color: #999;
  border-radius: 50%;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>